export enum StateRelation {
  COUNTIES = 'counties'
}
